import { faMicrophone } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from 'Button';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import './locales/TutorBotVoiceAgent/StartDiscussionButton-en.json';
import { TUTOR_BOT_BUTTON_HEIGHT_NUM_12_5 } from 'TutorBotConversation';
import { type SupportedColors } from '../../TutorBotVoiceAgent.types';

type Props = {
    onPress: () => void;
    iconOnly?: boolean;
    color: SupportedColors | undefined;
    content: string | undefined | null;
};

export function StartDiscussionButton({ onPress, color, content }: Props) {
    const { t } = useTranslation('back_royal', { keyPrefix: 'TutorBotVoiceAgent.StartDiscussionButton' });

    return (
        <Button
            onPress={onPress}
            radius="full"
            color={color === 'purple' ? 'purple-gradient' : 'primary-gradient'}
            height={TUTOR_BOT_BUTTON_HEIGHT_NUM_12_5}
            icon={<FontAwesomeIcon className={clsx('text-md')} icon={faMicrophone} />}
        >
            {content ?? t('startDiscussion')}
        </Button>
    );
}
